import { render } from "./MasterButtom.vue?vue&type=template&id=42b31ea6&scoped=true"
import script from "./MasterButtom.vue?vue&type=script&lang=js"
export * from "./MasterButtom.vue?vue&type=script&lang=js"

import "./MasterButtom.vue?vue&type=style&index=0&id=42b31ea6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b31ea6"]])

export default __exports__